import { connect } from 'react-redux';
import { getEntities } from 'dash-front/selectors';
import { STORE_KEYS } from '../../constants';

const mapStateToProps = state => {
    return {
        templates: getEntities(state)[STORE_KEYS.TEMPLATES],
    };
};

export default connect(mapStateToProps);



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/enhancers/withTemplates.js
 **/